// packages/chatbot/src/components/ChatBrandFooter.tsx
import React from 'react';
import { Logo } from '@dopomogai/ui';

export const ChatBrandFooter: React.FC<{ brandSlot?: React.ReactNode; brandHref?: string }> = ({
  brandSlot,
  brandHref = 'https://dpmg.xyz',
}) => {
  // If a custom slot is provided, render it as-is to avoid nested anchors.
  if (brandSlot) {
    return (
      <div className="flex items-center justify-center gap-2 text-[11px] text-slate-500 border-t-2 border-black bg-white px-3 py-1.5">
        {brandSlot}
      </div>
    );
  }

  // Default: clickable footer with full logo (icon + text)
  return (
    <a
      href={brandHref}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center justify-center gap-2 text-[11px] text-slate-500 border-t-2 border-black bg-white px-3 py-1.5 hover:text-sky-600"
      aria-label="Powered by DopomogAI"
    >
      <span>Powered by</span>
      <Logo logoType="logo+icon" size="sm" />
    </a>
  );
};
